import { useState } from 'react';
import { CompressedFooter } from '@gc-bridge/components/Footer/Compressed';
import { ExpandedFooter } from '@gc-bridge/components/Footer/Expanded';
import { Box } from '@mui/material';

export const Footer = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
      }}
    >
      {!expanded ? (
        <CompressedFooter onExpand={() => setExpanded(true)} />
      ) : (
        <ExpandedFooter onShrink={() => setExpanded(false)} />
      )}
    </Box>
  );
};
